module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-month-6-cdda86b4485ed3885fbfcbd827c40173.svg";